import Instance from '../../../../Axios';

// New Actions for the app

const GetObrasEstadosEspecialidades = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/all/estadosEspecialidades`)
    .then(({ data }) => {
      dispatch({ type: 'GET_OBRAS_ESTADOS_ESPECIALIDADES', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasEstadosEspecialidades;